// extracted by mini-css-extract-plugin
export default {"Ambulancia":"Ambulancia_Ambulancia__SYJ17","margin":"Ambulancia_margin__Kjnu9","parallax":"Ambulancia_parallax__4suGS"};